import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Advertiser } from 'src/app/api/api-campaigns.service.generated';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PhotoComponent } from 'wecheer-common';

@Component({
  selector: 'app-advertiser-details',
  templateUrl: './advertiser-details.component.html',
  styleUrls: ['./advertiser-details.component.scss'],
  imports: [
    MatButtonModule,
    MatTooltipModule,
    PhotoComponent
  ]
})
export class AdvertiserDetailsComponent implements OnInit, OnChanges {

  @Input() advertiser: Advertiser;
  @Input() isFullScreen = false;

  isLoading = false;

  constructor(
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
  }

}
